import { 
  Button,
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  Divider, 
  Typography 
} from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"

export const TermsAndConditionsDialog = (props: { open: boolean, toggleDialog: (open: boolean) => void }) => {
  const {t} = useTranslation();
  return (
    <Dialog
      open={props.open}
      fullWidth
      onClose={() => props.toggleDialog(false)}
      maxWidth={"xl"}
    >
      <DialogTitle>{t("termsAndConitionsDialog.title")}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          <Typography>
            {t("termsAndConitionsDialog.text_content_1")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_2")}
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_3")}<br />
            {t("termsAndConitionsDialog.text_content_4")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_5")}<br />
            {t("termsAndConitionsDialog.text_content_6")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_7")}<br />
            {t("termsAndConitionsDialog.text_content_8")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_9")}<br />
            {t("termsAndConitionsDialog.text_content_10")}
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_11")}<br />
            {t("termsAndConitionsDialog.text_content_12")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_13")}<br />
            {t("termsAndConitionsDialog.text_content_14")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_15")}<br />
            {t("termsAndConitionsDialog.text_content_16")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_17")}<br />
            {t("termsAndConitionsDialog.text_content_18")}
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_19")}<br />
            {t("termsAndConitionsDialog.text_content_20")}
          </Typography>
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_21")}<br />
            {t("termsAndConitionsDialog.text_content_22")}
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_23")}<br />
            {t("termsAndConitionsDialog.text_content_24")}
          </Typography>
          <br />
          <Divider />
          <br />
          <Typography>
            {t("termsAndConitionsDialog.text_content_25")}<a href="https://www.medmindtechnology.hk">https://www.medmindtechnology.hk</a>{t("termsAndConitionsDialog.text_content_26")}<a href="mailto:info@medmindtechnology.hk" target="_blank">info@medmindtechnology.hk</a>{t("termsAndConitionsDialog.text_content_27")}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" disableElevation onClick={() => props.toggleDialog(false)} color="primary">
          {t("butt.close")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}